<template lang="pug">
  .component-action-buttons
    ul.dropdown.menu(v-if="$is('action')", data-dropdown-menu='', v-f="")
      li
        a(href='#') Action
        ul.menu
          li(v-for="action in actions")
            a(v-on:click="action.callback") {{ action.name }}
    .dropdown-buttons(v-else)
      button.button(v-for="action in actions", type="button", v-on:click="action.callback", :class="action.severity") {{ action.name }}
</template>
<script type="text/babel">
  export default {
    name: "ActionButtons",
    props: ['actions', 'type'],
  }
</script>
<style lang="sass" rel="stylesheet/sass">
  .dropdown-buttons > a
    display: block
</style>



// WEBPACK FOOTER //
// ActionButtons.vue?3b95d5e0